<template>
  <div>
    <BigTitle :bigtitle="bigtitle"></BigTitle>
    <!-- 考核指标 -->
    <Indicators :userList="assessTargetList" :type="'batteryHolder'"></Indicators>
  </div>
</template>
<script>
import BigTitle from '@/components/bigTitle';
import Indicators from '@/components/common/indicators';
import { dataInterface } from '@/api/dataInterfaceApi';



export default {
  data () {
    return {
      options: {},
      bigtitle:{
        CHN:'成本分析',
        ENG:'Cost analysis'
      },
      assessTargetList:[{
        counts:0,
        text:"收入(元)",
        percent:"0%"
      },{
        counts:0,
        text:"累计成本(元)",
        percent:"0%"
      },{
        counts:0,
        text:"贡献利润",
        percent:"0%"
      }]
    };
  },
  components: {
    BigTitle,
    Indicators
  },
  props: {

  },
  watch: {
    
  },
  mounted () {
  },
  methods: {
    getData(data){
      this.selectBatteryCostAnalyst(data);
    },
    selectBatteryCostAnalyst(data={}){
      let _this = this;
      let params = {
            "enCode":"TiDB-congdiancang-chengbenfenxi",
      			"@battery_id":data.batteryId
          }
          dataInterface
          .dataFaceApi(params)
        .then((res) => {
          if(!res) return;
          res = res[0];
          _this.assessTargetList = [{
              counts:res.rcvAmount,
              text:"本月收入(元)",
              percent:res.rcvAmountRateAdd
            },{
              counts:res.costAmount,
              text:"本月成本(元)",
              percent:res.costAmountRateAdd
            },{
              counts:res.profitAmount,
              text:"本月贡献利润",
              percent:res.profitAmountRateAdd
          }];
        })
        .catch((err) => {
          console.log(err);
        });
    },
  }
}
</script>
<style lang="scss" scoped>

</style>